"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../../core");
var resolve_path_in_object_1 = require("../../../core/lang/resolve-path-in-object");
var type_function_1 = require("../../../core/lang/type-function");
var irender_reason_1 = require("../interface/irender-reason");
var change_type_1 = require("../../../core/cd/interface/change-type");
exports.STORE_MOUNTS = "STORE_MOUNTS";
var reduxStore;
var StoreTrait = /** @class */ (function () {
    function StoreTrait() {
    }
    StoreTrait.enableFor = function (instance) {
        var storeMounts = Object.getPrototypeOf(instance).constructor[exports.STORE_MOUNTS] || {};
        if (!reduxStore)
            return;
        StoreTrait.setMountStateValues(storeMounts, instance);
        reduxStore.subscribe(function () {
            StoreTrait.setMountStateValues(storeMounts, instance);
        });
    };
    StoreTrait.setMountStateValues = function (storeMounts, instance) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _i, name_1, value, prevValue;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = [];
                        for (_b in storeMounts)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        name_1 = _a[_i];
                        if (!!instance.el) return [3 /*break*/, 3];
                        return [4 /*yield*/, instance.initiallyRendered()];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        ;
                        value = resolve_path_in_object_1.resolvePathInObject(storeMounts[name_1], reduxStore.getState());
                        prevValue = instance[name_1];
                        // redux store value map to instance property
                        // @ts-ignore
                        instance[name_1] = value;
                        if (typeof instance.onStoreChange == type_function_1.TYPE_FUNCTION) {
                            instance.onStoreChange(name_1, value);
                        }
                        if (instance.shouldRender(irender_reason_1.RenderReason.STORE_CHANGE, {
                            name: name_1,
                            path: storeMounts[name_1],
                            prevValue: prevValue,
                            type: change_type_1.ChangeType.REFERENCE,
                            value: value
                        })) {
                            instance.doRender();
                        }
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    StoreTrait.addStoreMount = function (ctor, mountName, selector) {
        // validate
        if (process.env.NODE_ENV === "development") {
            if (core_1.st.dom.isStandardHTMLAttribute(mountName)) {
                core_1.st.error("The store mount " + ctor.name + "." + mountName + " is a standard HTML element attribute. It's value would be written directly to this.el, hiding away from @attr. Please choose a different name.");
            }
        }
        // init cache
        if (!ctor[exports.STORE_MOUNTS]) {
            ctor[exports.STORE_MOUNTS] = {};
        }
        // register
        ctor[exports.STORE_MOUNTS][mountName] = selector;
    };
    return StoreTrait;
}());
exports.StoreTrait = StoreTrait;
if (!core_1.st.getStore) {
    core_1.st.getStore = function () {
        return reduxStore;
    };
    core_1.st.setStore = function (store) {
        reduxStore = store;
    };
}
//# sourceMappingURL=store.js.map